import React, { useCallback, useEffect, useRef, useState } from "react";
import logo from "../../images/logo.png";
import ngSvg from "../../images/svgs/ng.svg";
import saSvg from "../../images/sa.svg";
import dropDownSvg from "../../images/svgs/arrow.svg";
import { NavLink } from "react-router-dom";
import { useRecoilState } from "recoil";
import { auth_user } from "../../atom";
import { saveToken } from "../../lib/utils";
import { useNavigate } from "react-router-dom";
import { useLogout } from "../../api/mutations";

const Nav = ({ isPublic = false }) => {
  const [user, set_user] = useRecoilState(auth_user);
  const [openModal, setOpenModal] = useState(false);
  const [toggleCountry, setToggle] = useState(false);
  const [selectecCountry, setSelectedCountry] = useState({
    img: ngSvg,
    name: "NGN",
  });
  const ref = useRef(null);
  const navigate = useNavigate();
  const { mutateAsync } = useLogout();

  const handleLogout = useCallback(async () => {
    try {
      await mutateAsync();
      set_user({});
      saveToken("accessToken", "");
      saveToken("refreshToken", "");
      navigate("/");
    } catch (e) {}
  }, []);

  useEffect(() => {
    document.addEventListener(
      "click",
      function (e) {
        if (!ref.current?.contains(e.target)) {
          setOpenModal(false);
        }
      },
      true
    );
  }, [ref]);

  return (
    <div className="landing-row">
      <nav class="navbar navbar-expand-lg">
        <div class="container-fluid">
          <NavLink to="/">
            <div style={{ backgroundColor: "#fff" }}>
              <img src={logo} className="img-fluid logo" alt="logo" />
            </div>
          </NavLink>

          <ul className="flex items-center">
            <li class="nav-item">
              <NavLink to="/">
                <span class="nav-link" aria-current="page">
                  Free Bet codes
                </span>
              </NavLink>
            </li>
            {!isPublic && Object.keys(user).length ? (
              <li class="nav-item">
                <NavLink to="/mybets">
                  <span class="nav-link">My Bets</span>
                </NavLink>
              </li>
            ) : null}
          </ul>
          <div class="flex" id="navbarText">
            <div className="flex justify-center items-center gap-0">
              <div
                onClick={() => setToggle((prev) => !prev)}
                className="flex cursor-pointer relative justify-center mt-[20px] items-center gap-2"
              >
                <img src={selectecCountry.img} className="w-[25px] h-[25px]" />
                <h4 className="font-bold text-sm text-black-100">
                  {selectecCountry.name}
                </h4>
                <img src={dropDownSvg} className="w-[20px] h-[20px]" />
                {toggleCountry && (
                  <div
                    ref={ref}
                    className="absolute w-[100px] mt-[80px] h-fit py-2 bg-white shadow-md rounded-md p-4"
                  >
                    <p
                      onClick={() => {
                        if (selectecCountry.name === "NGN") {
                          setSelectedCountry({
                            img: saSvg,
                            name: "SA",
                          });
                        } else if (selectecCountry.name === "SA") {
                          setSelectedCountry({
                            img: ngSvg,
                            name: "NGN",
                          });
                        }
                      }}
                      className="font-medium cursor-pointer text-sm text-black"
                    >
                      <div className="flex cursor-pointer relative justify-center mt-[20px] items-center gap-2">
                        <img
                          src={selectecCountry.name === "NGN" ? saSvg : ngSvg}
                          className="w-[25px] h-[25px]"
                        />
                        <h4 className="font-bold text-sm text-black-100">{selectecCountry.name === "NGN" ? "SA" : "NGN"}</h4>
                      </div>
                    </p>
                  </div>
                )}
              </div>

              {Object.keys(user ?? {}).length && !isPublic ? (
                <div className="flex cursor-pointer relative justify-center mt-[20px] ml-6 items-center gap-2">
                  <h4 className="font-bold text-sm text-black-100">
                    Hi, {user?.username}
                  </h4>
                  <img
                    onClick={() => setOpenModal((prev) => !prev)}
                    src={dropDownSvg}
                    className="w-[20px] h-[20px]"
                  />
                  {openModal && (
                    <div
                      ref={ref}
                      className="absolute w-[100px] mt-[80px] h-fit py-2 bg-white shadow-md rounded-md p-4"
                    >
                      <p
                        onClick={handleLogout}
                        className="font-medium cursor-pointer text-sm text-black"
                      >
                        Logout
                      </p>
                    </div>
                  )}
                </div>
              ) : (
                <span class="navbar-text mt-6">
                  <NavLink to="/signup">
                    <button className="btn-copy-header">Get started</button>
                  </NavLink>
                </span>
              )}
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Nav;
